import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { useCreateReturn } from '../../return/create-return/use-create-return';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';
import { EventSourceStrings } from '../../../../tracking/tracking-constants';

import messages from './messages';

export const CreateReturnButton = () => {
  const salesOrderId = useSalesOrderIdContext();
  const { createReturn, isCreateReturnDisabled } = useCreateReturn(salesOrderId, EventSourceStrings.ORDER_DETAILS_HEADER);

  if (isCreateReturnDisabled) {
    return null;
  }

  return (
    <Button onClick={createReturn} theme='tertiary'>
      <FormattedMessage {...messages.createReturn} />
    </Button>
  );
};
